import React from "react";
import { motion } from "framer-motion";
import { BarChart3, Radio, Handshake, Send, Mail, Newspaper, LineChart, Target } from "lucide-react";

const nodes = [
  { icon: LineChart, label: "Analytics", desc: "Data insights that power smarter decisions." },
  { icon: BarChart3, label: "Performance Marketing", desc: "ROI-driven campaigns that deliver results." },
  { icon: Radio, label: "Media Buying", desc: "Strategic placements across the right platforms." },
  { icon: Target, label: "Paid Media", desc: "Targeted ads that maximize reach & conversions." },
  { icon: Handshake, label: "Affiliate Marketing", desc: "Performance-based partnerships that scale growth." },
  { icon: Newspaper, label: "Public Relations", desc: "Build reputation. Earn trust. Grow brand value." },
  { icon: Send, label: "SMS Marketing", desc: "Direct. Instant. Effective engagement." },
  { icon: Mail, label: "Email Marketing", desc: "Personalized emails that nurture & convert." },
];

export default function Ecosystem() {
  return (
    <section id="ecosystem" className="relative py-32 bg-[#070707] border-y border-white/5 overflow-hidden">
      <div className="aurora bg-[#C9A227] w-[500px] h-[500px] -top-40 left-1/2 -translate-x-1/2" style={{opacity:0.18}} />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto">
          <span className="eyebrow-emerald">Digital Growth Ecosystem</span>
          <h2 className="mt-6 text-4xl md:text-6xl font-semibold">
            Everything your business needs to <span className="text-gold-gradient">scale digitally</span>
          </h2>
          <p className="mt-6 text-white/60 text-lg">
            One partner. Complete digital growth solution. SYR combines AI, creativity,
            performance marketing, branding, web development and business automation into
            one powerful ecosystem.
          </p>
        </div>

        <div className="relative mt-20 grid md:grid-cols-3 lg:grid-cols-4 gap-5">
          {nodes.map((n, i) => (
            <motion.div
              key={n.label}
              initial={{opacity:0, y:20}}
              whileInView={{opacity:1, y:0}}
              viewport={{once:true}}
              transition={{duration:0.5, delay: (i%4)*0.08, ease:[0.16,1,0.3,1]}}
              className="card-lift glass rounded-2xl p-6 relative"
            >
              <div className="w-11 h-11 rounded-lg grid place-items-center bg-gradient-to-br from-[#C9A227]/20 to-[#047857]/10 border border-white/10">
                <n.icon size={18} className="text-[#F4D983]" />
              </div>
              <div className="mt-4 font-semibold text-lg">{n.label}</div>
              <div className="mt-2 text-sm text-white/55 leading-relaxed">{n.desc}</div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 flex items-center justify-center gap-3">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-[#C9A227]" />
          <span className="text-xs uppercase tracking-[0.3em] text-white/50">One Partner · Complete Digital Growth Solution</span>
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-[#C9A227]" />
        </div>
      </div>
    </section>
  );
}
